import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { DataGrid, GridValueFormatterParams } from "@material-ui/data-grid";
import { Fragment, useCallback, useEffect, useState } from "react";
import { Button, useDataProvider } from "react-admin";
import RegeneratePdfButton from "./RegeneratePdfButton";

interface IShowDetailButton {
  detailId: number;
}

const ShowDetailButton = ({ detailId }: IShowDetailButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const [customerLedgers, setCustomerLedgers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
  });

  const classes = useStyles();
  const provider = useDataProvider();

  const getCustomerLedgers = (id: number) => {
    setLoading(true);
    provider.customGetOne(`invoices/${id}`).then(({ data }: any) => {
      var tempCnDocuments: any = [];
      data.taggedCreditNoteDocuments.forEach((item: any) => {
        item.documentId = item.id;
        item.id = item.id + 100;
        tempCnDocuments.push(item);
      });

      setCustomerLedgers([
        ...data.taggedCashReceiptDocuments,
        ...tempCnDocuments,
      ]);
      setLoading(false);
    });
  };

  console.log("customer", customerLedgers);

  useEffect(() => {
    if (open) {
      getCustomerLedgers(detailId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const GetPdf = (id: number) => {
    provider
      .getOne("creditNotes", {
        id: id,
      })
      .then(({ data }) => {
        window.open(data.pdfUrl, "_blank");
      });
  };

  const ShowPdfButton = (props: any) => {
    console.log(props);
    return (
      <div>
        {props.data.row.pdfUrl !== null && (
          <Button
            onClick={() => {
              GetPdf(props.data.row.documentId);
            }}
            label="Show PDF"
          />
        )}
        <RegeneratePdfButton accountingDocumentNumber={props.data.row.number} />
      </div>
    );
  };

  const customerLedgerColumns = [
    {
      field: "number",
      headerName: "Invoice Number",
      type: "string",
      flex: 1,
      filterable: false,
    },
    {
      field: "total",
      headerName: "Amt. Include VAT",
      type: "number",
      flex: 1,
      filterable: false,
      valueFormatter: (params: GridValueFormatterParams) =>
        `$ ${(Number(params.value) / 100).toLocaleString()}`,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 2,
      filterable: false,
      renderCell: (props: any) => {
        return <ShowPdfButton data={props} />;
      },
    },
  ];

  const onFilterChange = useCallback((filterModel: any) => {
    // setFilterValue(filterModel.items[0].value);
    console.log("TEST", filterModel);
  }, []);

  return (
    <Fragment>
      <Button label={`Show Detail`} onClick={handleOpenDialog} />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">Details Of Invoice</DialogTitle>
        <DialogContent>
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={customerLedgers}
              columns={customerLedgerColumns}
              pageSize={100}
              rowsPerPageOptions={[100]}
              // filterMode="server"
              onFilterModelChange={onFilterChange}
              loading={loading}
              disableColumnMenu
            ></DataGrid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ShowDetailButton;
